import DynamicFieldBase from '@linc-technologies/linced-common/components/dynamic-field-base';

// The component behind <DynamicField>, pairing DynamicFieldBase's behaviour with
// the colocated dynamic-field.hbs template. All the logic lives in the base; see
// the comment there for why the split exists. Subclass this for ordinary reuse,
// but subclass DynamicFieldBase for anything dynamic-field.hbs itself invokes.
export default class DynamicField extends DynamicFieldBase {}
